import { MusicMemCondition, MusicMemPurchaseCondition } from './constants';
import typeHints from './typeHints';

const attributes = {

  music_item_type: {
    friendly: 'Item Type',
    validations: {
      maxLength: 150,
    },
  },

  music_band: {
    friendly: 'Band',
    validations: {
      maxLength: 150,
    },
  },

  music_year: {
    friendly: 'Year',
    validations: {
      type: 'integer',
      mustBePositive: true,
    },
  },

  music_genre: {
    friendly: 'Genre',
    validations: {
      maxLength: 150,
    },
  },

  music_editon: {
    friendly: 'Editon',
    validations: {
      maxLength: 255,
    },
  },

  music_maker: {
    friendly: 'Maker',
    validations: {
      maxLength: 150,
    },
  },

  music_material: {
    friendly: 'Material',
    validations: {
      maxLength: 255,
    },
  },

  music_dimensions: {
    friendly: 'Dimensions',
    validations: {
      maxLength: 150,
    },
  },

  music_weight: {
    friendly: 'Weight',
    validations: {
      maxLength: 150,
    },
  },

  music_signed: {
    friendly: 'Signed',
    validations: {
      maxLength: 255,
    },
    typeHint: typeHints.TextArea,
  },

  music_accessories: {
    friendly: 'Accessories',
    validations: {
      maxLength: 255,
    },
  },

  music_country: {
    friendly: 'Country',
    validations: {
      maxLength: 150,
    },
  },

  music_conditon: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: MusicMemCondition,
    },
  },

  music_purchase_conditon: {
    friendly: 'Purchase Condition',
    validations: {
      type: 'enum',
      enumType: MusicMemPurchaseCondition,
    },
  },

};

export default attributes;

export const MusicMemDefaultSplitAttribute = 'music_item_type';

export const MusicMemItemSearchAttributes = [];

export const MusicMemOverviewAttributes = ['title', 'music_item_type', 'music_band', 'music_year', 'music_country', 'music_conditon', 'rarity',
  'market_value', 'quantity', 'inventory_no', 'tags',
];

export const MusicMemSpecificationAttributes = ['music_genre', 'music_editon', 'music_maker', 'music_material', 'music_dimensions', 'music_weight',
  'music_signed', 'music_accessories',
];

export const MusicMemPurchaseAttributes = ['purchase_date', 'purchase_price', 'music_purchase_conditon', 'purchase_contact', 'purchase_notes'];

export const MusicMemDetailAttributes = [];

export const MusicMemRequiredAttributes = [];

export const MusicMemDisplayAttributes = ['music_item_type', 'music_band', 'music_genre', 'music_year', 'tags'];

export const MusicMemSliderGalleryAttributes = {
  titleKey: 'music_item_type',
  subtitleKey: 'music_band',
};



// WEBPACK FOOTER //
// ./src/config/musicMemorabiliaDataAttributes.js